<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1>لیست تخفیف های دوره</h1>
          <div class="d-flex flex-column flex-md-row mt-2" style="gap: 1rem">
            <b-button variant="success" @click="renderCreateDiscountModal">
              ایجاد تخفیف جدید
            </b-button>
            <b-button variant="primary" @click="renderCreateCouponModal">
              ایجاد کوپن جدید
            </b-button>
          </div>
          <h2 class="mt-4">تخفیف ها</h2>
          <hr />
          <div class="my-2">
            <!-- Table Top Start -->
            <b-row>
              <!-- Search -->
              <b-col cols="12" md="6">
                <b-form-group label="از تاریخ" label-for="fromDate">
                  <b-form-input
                    class="fromDate"
                    id="fromDate"
                    placeholder="تاریخ شروع تخفیف را وارد کنید"
                  ></b-form-input>
                  <date-picker
                    v-model="fromDate"
                    class="absolute"
                    customInput=".fromDate"
                    display-format="jYYYY/jMM/jDD"
                    input-format="jYYYY/jMM/jDD"
                    format="YYYY-MM-DD"
                  ></date-picker>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="تا تاریخ" label-for="toDate">
                  <b-form-input
                    class="toDate"
                    id="toDate"
                    placeholder="تاریخ پایان تخفیف را وارد کنید"
                  ></b-form-input>
                  <date-picker
                    v-model="toDate"
                    class="absolute"
                    customInput=".toDate"
                    display-format="jYYYY/jMM/jDD"
                    input-format="jYYYY/jMM/jDD"
                    format="YYYY-MM-DD"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Table Top End -->
          </div>
          <b-table
            ref="refUserListTable"
            class="position-relative mt-2"
            :items="discountList"
            responsive
            :fields="discountTableCols"
            primary-key="discountId"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(type)="data">
              {{ discountTypesEnum[data.item.type] }}
            </template>
            <template #cell(value)="data">
              <template v-if="data.item.type == 1">
                {{ Intl.NumberFormat("en-US").format(data.item.value) }} تومان
              </template>
              <template v-else>{{ data.item.value }}%</template>
            </template>

            <template #cell(startDate)="data">
              {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(expireDate)="data">
              {{ new Date(data.item.expireDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(courseTitle)="data">
              <b-link :to="`/courses/${data.item.courseId}`">
                {{ data.item.courseTitle }}
              </b-link>
            </template>
            <template #cell(actions)="data">
              <div class="d-flex align-items-center">
                <feather-icon
                  v-b-modal.modal-discount-edit
                  @click="renderEditDiscountModal(data.item)"
                  class="text-primary mr-2 cursor-pointer"
                  icon="EditIcon"
                  size="20"
                />
                <feather-icon
                  @click="renderDeleteDiscountModal(data.item)"
                  class="text-danger cursor-pointer"
                  icon="Trash2Icon"
                  size="20"
                />
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="discountPageNumber"
              :total-rows="discountTotalCount"
              :per-page="discountCount"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
          <h2 class="mt-4">کوپن ها</h2>
          <hr />
          <b-table
            ref="refUserListTable"
            class="position-relative mt-2"
            :items="couponList"
            responsive
            :fields="couponTableCols"
            primary-key="discountId"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
          >
            <template #cell(type)="data">
              {{ couponTypesEnum[data.item.type] }}
            </template>
            <template #cell(couponValue)="data">
              <template v-if="data.item.type == 2">
                {{ Intl.NumberFormat("en-US").format(data.item.couponValue) }}
                تومان
              </template>
              <template v-else>{{ data.item.couponValue }}%</template>
            </template>
            <template #cell(baseQuantity)="data">
              <template v-if="data.item.baseQuantity">
                {{ data.item.baseQuantity }}
              </template>
              <template v-else> بدون سقف استفاده </template>
            </template>
            <template #cell(lessonTitle)="data">
              <b-link :to="`/lessons/${data.item.lessonId}`">
                {{ data.item.lessonTitle }}
              </b-link>
            </template>
            <template #cell(startDate)="data">
              {{ new Date(data.item.startDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(endDate)="data">
              {{ new Date(data.item.endDate).toLocaleDateString("fa-IR") }}
            </template>
            <template #cell(actions)="data">
              <div class="d-flex align-items-center">
                <feather-icon
                  v-b-modal.modal-coupon-edit
                  @click="renderEditCouponModal(data.item)"
                  class="text-primary mr-2 cursor-pointer"
                  icon="EditIcon"
                  size="20"
                />
                <feather-icon
                  @click="renderDeleteCouponModal(data.item)"
                  class="text-danger cursor-pointer"
                  icon="Trash2Icon"
                  size="20"
                />
              </div>
            </template>
          </b-table>
          <b-col
            cols="12"
            class="d-flex align-items-center justify-content-center py-2"
          >
            <b-pagination
              v-model="couponPageNumber"
              :total-rows="couponTotalCount"
              :per-page="couponCount"
              first-number
              last-number
              class="mb-0 mt-1"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  style="transform: rotate(180deg)"
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-card>
      </b-col>
    </b-row>
    <create-discount-modal
      :discountFor="'course'"
      @reFetch="getAllDiscounts"
    ></create-discount-modal>
    <create-coupon-modal :discountFor="'course'"></create-coupon-modal>
    <delete-confirmation-modal
      @closeModal="closeDeleteConfirmationModal"
      @deleteDiscount="deleteADiscount"
      @deleteCoupon="deleteACoupon"
      :offerType="tempType"
    ></delete-confirmation-modal>
    <edit-discount-modal
      @reFetch="getAllDiscounts"
      :defaultDiscount="tempDiscount"
    ></edit-discount-modal>
    <edit-coupon-modal
      :defaultCoupon="tempCoupon"
      @reFetch="getAllCoupons"
    ></edit-coupon-modal>
  </b-overlay>
</template>
<script>
import CreateDiscountModal from "@/views/components/Offers/CreateDiscountModal.vue";
import EditDiscountModal from "@/views/components/Offers/EditDiscountModal.vue";
import CreateCouponModal from "@/views/components/Offers/CreateCouponModal.vue";
import EditCouponModal from "@/views/components/Offers/EditCouponModal.vue";
import DeleteConfirmationModal from "@/views/components/Offers/DeleteConfirmationModal.vue";
import { GetAllDiscounts, DeleteADiscount } from "@/libs/Api/Discount";
import { GetAllCoupons, DeleteACoupon } from "@/libs/Api/Coupon";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BModal,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  watch: {
    fromDate: {
      handler(val) {
        this.getAllDiscounts();
      },
    },
    toDate: {
      handler(val) {
        this.getAllDiscounts();
      },
    },
    couponPageNumber: {
      handler(val) {
        this.getAllCoupons();
      },
    },
    discountPageNumber: {
      handler(val) {
        this.getAllDiscounts();
      },
    },
  },
  mounted() {
    this.getAllDiscounts();
    this.getAllCoupons();
  },
  data() {
    return {
      isLoading: false,
      discountCount: 10,
      discountPageNumber: 1,
      fromDate: null,
      toDate: null,
      discountTotalCount: null,
      discountList: null,
      discountTypesEnum: {
        1: "مبلغ",
        2: "درصد",
      },
      couponTypesEnum: {
        1: "درصد",
        2: "مبلغ",
      },
      discountTableCols: [
        {
          key: "discountId",
          label: "شناسه تخفیف",
        },
        {
          key: "type",
          label: "نوع تخفیف",
        },
        {
          key: "value",
          label: "مقدار تخفیف",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
        },
        {
          key: "expireDate",
          label: "تاریخ پایان",
        },
        {
          key: "courseTitle",
          label: "نام دوره",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      couponTableCols: [
        {
          key: "couponId",
          label: "شناسه کوپن",
        },
        {
          key: "type",
          label: "نوع کوپن",
        },
        {
          key: "couponValue",
          label: "مقدار تخفیف",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
        },
        {
          key: "endDate",
          label: "تاریخ پایان",
        },
        {
          key: "code",
          label: "کد کوپن",
        },
        {
          key: "maintainedQuantity",
          label: "تعداد قابل استفاده از کوپن",
        },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      couponCount: 10,
      couponPageNumber: 1,
      couponTotalCount: null,
      couponLessonId: null,
      couponUserId: null,
      couponList: null,
      tempItem: null,
      tempType: null,
      tempDiscount: null,
      tempCoupon: null,
    };
  },
  methods: {
    renderEditDiscountModal(item) {
      this.tempDiscount = item;
      this.$bvModal.show("modal-discount-edit");
    },
    renderEditCouponModal(item) {
      this.tempCoupon = item;
      this.$bvModal.show("modal-coupon-edit");
    },
    closeDeleteConfirmationModal() {
      this.$bvModal.hide("modal-item-delete");
      this.tempItem = null;
      this.tempType = null;
    },
    renderDeleteDiscountModal(item) {
      this.tempType = 1;
      this.tempItem = item;
      this.$bvModal.show("modal-item-delete");
    },
    renderDeleteCouponModal(item) {
      this.tempType = 2;
      this.tempItem = item;
      this.$bvModal.show("modal-item-delete");
    },
    renderCreateDiscountModal() {
      this.$bvModal.show("modal-discount-add");
    },
    renderCreateCouponModal() {
      this.$bvModal.show("modal-coupon-add");
    },
    async deleteADiscount() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteADiscount = new DeleteADiscount(_this);
        deleteADiscount.setRequestParam({ id: _this.tempItem.discountId });
        await deleteADiscount.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "تخفیف با موفقیت حذف شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.closeDeleteConfirmationModal();
            _this.getAllDiscounts();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async deleteACoupon() {
      try {
        this.isLoading = true;
        let _this = this;
        let deleteCoupon = new DeleteACoupon(_this);
        deleteCoupon.setRequestParam({
          id: _this.tempItem.couponId,
        });
        await deleteCoupon.fetch((response) => {
          if (response) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "کوپن با موفقیت حذف شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.closeDeleteConfirmationModal();
            _this.getAllCoupons();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllDiscounts() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllDiscounts = new GetAllDiscounts(_this);
        let qParams = {
          count: _this.discountCount,
          pageNumber: _this.discountPageNumber,
          searchType: 1,
        };
        if (this.fromDate) {
          qParams["fromDate"] = this.fromDate;
        }
        if (this.toDate) {
          qParams["toDate"] = this.toDate;
        }
        getAllDiscounts.setRequestParam(qParams);
        await getAllDiscounts.fetch((response) => {
          if (response.isSuccess) {
            _this.discountTotalCount = response.data.discountsCount;
            _this.discountList = response.data.discounts;
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllCoupons() {
      console.log("Hey");
      try {
        this.isLoading = true;
        let _this = this;
        let getAllCoupons = new GetAllCoupons(_this);
        let qParams = {
          count: _this.couponCount,
          pageNumber: _this.couponPageNumber,
        };
        if (this.couponLessonId) {
          qParams["lessonId"] = _this.couponLessonId;
        }
        getAllCoupons.setRequestParam(qParams);
        await getAllCoupons.fetch((response) => {
          _this.couponList = response.coupons;
          _this.couponTotalCount = response.couponsCount;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    CreateDiscountModal,
    EditDiscountModal,
    CreateCouponModal,
    DeleteConfirmationModal,
    EditCouponModal,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BModal,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
